import { reactive } from 'vue'

export const $messageModal = reactive({
  isShow: false,
  title: '',
  content: '',
  buttonText: '',
  callback: null,
  show(params = {}) {
    this.title = params.title || '';
    this.content = params.content || '';
    this.buttonText = params.buttonText || 'Понятно';
    this.callback = params.callback || null;
    this.isShow = true;
  },
  hide() {
    this.isShow = false;
    this.callback = null;
  }
});

export default {
  install(app) {
    app.config.globalProperties.$messageModal = $messageModal;
    app.provide('$messageModal', $messageModal);
  }
}
